import { WebinarEvent } from "../../../_components/webinar/types";
import { calculateWebinarEventStatus } from "./calculate-webinar-event-status";

// Helper function to check if meeting link is available (webinar-specific)

export function isWebinarLinkTimeWindowActive(
    event: Pick<WebinarEvent, "linkActiveDate" | "date" | "duration">,
): boolean {
    const status = calculateWebinarEventStatus(event.date, event.duration);
    if (status === "ended") return false;
    if (!event.linkActiveDate) return true; // If no active date set, link is available
    return new Date() >= new Date(event.linkActiveDate);
}
